import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { AbstractDialogResultData, AbstractFormDialog, AbstractFormDialogData, DIALOG_RETURN_TYPES, FormDialogComponent } from '@next/core-lib/dialog';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

import { WaterAuthority, WaterAuthorityUpsertRequest } from '../../models/water-authorities.model';

export interface WaterAuthorityDialogData extends AbstractFormDialogData {
  waterAuthority?: WaterAuthority;
}

@Component({
  selector: 'app-water-authority-dialog',
  templateUrl: './water-authority-dialog.component.html',
  styleUrls: ['./water-authority-dialog.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatSlideToggle, FormDialogComponent, AgrI18nSharedModule],
})
export class WaterAuthorityDialogComponent extends AbstractFormDialog<WaterAuthorityUpsertRequest> implements OnInit {
  public readonly data = inject<WaterAuthorityDialogData>(MAT_DIALOG_DATA);
  private readonly formBuilder = inject(FormBuilder);
  protected readonly mdDialogRef = inject<MatDialogRef<WaterAuthorityDialogComponent, AbstractDialogResultData<WaterAuthorityUpsertRequest>>>(MatDialogRef);
  isEditMode = !!this.data.waterAuthority;

  formGroup: FormGroup = this.formBuilder.group({
    id: [null as number | null],
    displayName: [null as string | null, [Validators.required]],
    isActive: [true, [Validators.required]],
    nationalCode: [null as string | null, [Validators.required]],
  });

  ngOnInit(): void {
    if (this.data.waterAuthority) {
      this.formGroup.patchValue({
        id: this.data.waterAuthority.id,
        displayName: this.data.waterAuthority.displayName,
        isActive: this.data.waterAuthority.isActive,
        nationalCode: this.data.waterAuthority.nationalCode,
      });
    }
  }

  confirm(): void {
    if (this.formGroup.valid) {
      const formValue = this.formGroup.value;
      const result = this.isEditMode ? formValue : { ...formValue, id: undefined };
      this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.confirm, result });
    }
  }

  cancel(): void {
    this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.cancel });
  }
}
